export default __webpack_public_path__ + "static/media/lindab_1225x220px.6a11c550.png";